import Checkbox from 'rc-checkbox';
import React from 'react';

import './CheckBox.css';

interface Props {
    name: string,
    checked: boolean | undefined,
    label: string,
    onChange: (e: Event) => void
}

const CheckBox: React.FC<Props> = ({name, checked, label, onChange}) => {
    const checkboxStyle = () => {
        switch (checked) {
            case true:
                return 'fa-check-square-o';
            case false:
                return 'fa-square-o';
            default:
                return 'fa-square';
        }
    }
    return <div className="filter-checkbox">
        <label>
            <i className={'fa ' + checkboxStyle()} />
            <Checkbox name={name} checked={checked} onChange={onChange} />
            <span>{label}</span>
        </label>
    </div>;
}

export default CheckBox;
